import { TimeDisplay } from '@/shared/ui/timeDisplay'
import { useStyles } from './styles'
import { SpecialOffer } from '@/entities/payments'
import { useTimer } from '@/shared/hooks/useTimer'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { goToStarterPack } from '@/app/routing/events'

export const StarterPackShopFrame = (props: SpecialOffer) => {
  const { discount, photo_url, ends_at, name, discount_color } = props
  const now = Date.now().toString()
  const { timeLeft } = useTimer(ends_at, now)
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.starterPack
  const units = lang[userLang].pages.units
  const { classes } = useStyles()
  return (
    <div className={classes.root} onClick={() => goToStarterPack()}>
      <div className={classes.imageWrapper}>
        <img src={photo_url} alt="" className={classes.packImage} />
        <div className={classes.discountContainer} style={{ background: discount_color }}>
          <span className={classes.discountText}>-{discount}%</span>
        </div>
      </div>
      <div className={classes.textAndTimeWrapper}>
        <span className={classes.heading}>{texts.info[name].name}</span>
        <div className={classes.timeLeftWrapper}>
          <div className={classes.timeLeftContainer}>
            <div className={classes.daysWrapper}>
              <span>
                {timeLeft.days} {units.days}
              </span>
            </div>
            <TimeDisplay
              timeLeft={timeLeft}
              styles={{
                background: 'rgba(17, 17, 17, 1)',
                boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 1) inset, 0px 1px 0px 0px rgba(72, 72, 72, 1)',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
